import axios from "axios";
import { useCallback, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { GlobalStates } from "../GlobalStates";

export const useAlerts = () => {
    const { setAlert } = useContext(GlobalStates);
    const { t } = useTranslation()
    const userRegisterAlerts = useCallback(async (alerts) => {

        // console.log(alerts, 'cia')
        if (alerts.includes('Email already taken')) {
            setAlert(t('Email already taken'))
        }
        if (alerts.includes("This attribute must be unique")) {
            setAlert(t('Organization name already taken'))
        }

    }, [])

    return {
        userRegisterAlerts
    }
}
